module.exports = __webpack_public_path__ + "img/14.883ff0ee.jpg";